var AddNetworkView = require('addnetworkview');
var SettingsView = require('settingsview');
var TopPrompt = require('./top-prompt-view.es6').default;
var SessionPromptHandler = require('sessionprompthandler');
var ConnectionPromptHandler = require('connectionprompthandler');
var ConversationPromptHandler = require('conversationprompthandler');
var ChannelPromptHandler = require('channelprompthandler');
var BufferNotificationHandler = require('buffernotificationhandler');
var BufferOverlayHandler = require('bufferoverlayhandler');
var ChannelView = require('channelview');
var ConversationView = require('conversationview');
var DialogView = require('dialogview');
var ServerLogView = require('serverlogview');
var Thread = require('thread');
var ThreadView = require('threadview');
var Keyboard = require('../lib/keyboard.es6').default;


var MainAreaView = Backbone.View.extend({
    el: '#mainwrapper',
    initialize: function (options) {
        this.timeContainer = $('#timeContainer');

        this.addNetwork = new AddNetworkView(options);
        this.settings = new SettingsView(options);
        this.topPrompt = new TopPrompt(options);
        this.topPrompt.on('layoutChange', this.timeLayoutChange, this);

        var promptHandler = new SessionPromptHandler(options);
        promptHandler.on('addOverlay', this.renderCurrentOverlay, this);

        this.model.on('currentBufferChange', this.currentBufferChange, this);
        this.model.on('doneLoading', this.doneLoading, this);

        this.model.buffers.on('add', this.bufferAdded, this);
        this.model.buffers.on('selectedChange', this.bufferSelectedChange, this);
        this.model.on('threadChange', this.renderThread, this);

        this.model.buffers.on('remove', this.bufferRemoved, this);
        this.model.buffers.on('reset', this.resetBuffers, this);

        this.bufferPanes = $('#bufferPanes');
        this.buffersContainer = $('#buffersContainer');
        this.threadContainer = $('#threadContainer');

        this.buffers = {};

        this.checkDelayedLoads();

        this.bindDocEvents();

        this.model.bind('focusChange', this.focusChange, this);

        this.renderTimeFrame();
    },
    bindDocEvents: function () {
        $(window).resize(_.bind(this.windowResize, this));
        $(document).on('paste keydown', _.bind(this.docKeyDown, this));
        $(document).on('keyup', _.bind(this.docKeyUp, this));
        $(document).on('click', _.bind(this.docClick, this));
        var selectionChange = _.debounce(_.bind(this.onSelectionChange, this), 200);
        $(document).on('selectionchange mouseup', selectionChange);
    },
    focusChange: function () {
        if (this.current) {
            this.current.focusChange();
        }
    },
    timeLayoutChange: function () {
        if (!(this.current && this.model.isBacklogLoaded())) {
            return;
        }
        var cell;
        var timeRight = true;
        if (this.current) {
            cell = this.current.timeCell;
            timeRight = this.current.buffer.isTimeRight();
        }
        var offset = cell.offset();
        this.timeContainer.css({
            'top': offset.top,
            'left': offset.left - (timeRight ? 0 : 4),
            'width': cell.width(),
            'height': cell.height(),
            'line-height': cell.height() + 'px',
            'text-align': timeRight ? 'left' : 'right'
        });
        this.renderTime();
        this.timeContainer.show();
    },
    renderTimeFrame: function () {
        var self = this;
        requestAnimationFrame(function () {
            self.renderTime();
            setTimeout(function () {
                self.renderTimeFrame();
            }, 500);
        });
    },
    renderTime: function () {
        if (!this.current) {
            return;
        }
        var date = new Date();

        var fullDateString = date.formatFullDate();
        if (this.lastFullDateString != fullDateString) {
            this.lastFullDateString = fullDateString;
            this.timeContainer.attr('title', fullDateString);
        }
        var dateString = date.formatTime();
        if (this.lastDateString != dateString) {
            this.lastDateString = dateString;
            this.timeContainer.text(dateString);
        }
    },
    windowResize: function (e) {
        if (this.current) {
            this.current.scroll.checkPinBottom(function (pinBottom) {
                this.current.scroll.setResizing();
                this.current.fullLayoutChange(pinBottom);
                this.timeLayoutChange();
            }, this, { checkRecent: true });
        }
        if (this.currentThread) {
            this.currentThread.scroll.checkPinBottom(function (pinBottom) {
                this.currentThread.scroll.setResizing();
                this.currentThread.fullLayoutChange(pinBottom);
            }, this, { checkRecent: true });
        }
    },
    handlePaste: function (e) {
        if (this.suppressPaste) {
            return;
        }
        this.current.input.collectPasteData(e).done(_.bind(function (e, strings, files) {
            this.pasteTimeout = setTimeout(_.bind(function () {
                if (this.current) {
                    this.current.input.handlePasteData(e, strings, files);
                    this.pasteTimeout = null;
                }
            }, this), 100);
        }, this));
    },
    cancelPaste: function () {
        if (this.pasteTimeout) {
            clearTimeout(this.pasteTimeout);
            this.pasteTimeout = null;
        } else {
            this.suppressPaste = true;
            setTimeout(_.bind(function () {
                this.suppressPaste = false;
            }, this), 200);
        }
    },
    docClick: function (e) {
        if (e.button == 1 && $(e.target).is('a')) {
            this.cancelPaste();
        }
    },
    onSelectionChange: function () {
        if (this.current) {
            this.current.trigger('textSelectionChange');
        }
    },
    docKeyDown: function (e) {
        if (e.which === Keyboard.KEYS.ESC) {
            if (this.current) {
                this.current.clearReplyHighlight(true);
            }
            if (this.current && this.current.scroll.inputInfo.isVisible()) {
                this.current.scroll.inputInfo.makeOriginalChoice();
            } else {
                if (e.shiftKey) {
                    this.model.markAllAsRead();
                } else if (this.model.currentBuffer) {
                    this.model.currentBuffer.read();
                }
                return false;
            }
        }
        if (!this.current) {
            return;
        }
        // Input focus
        var modifier = e.metaKey || e.ctrlKey || (e.which < 48 && e.which !== 0);
        if (!$(e.target).is('input, textarea') && !DialogView.open) {
            if (e.type == 'paste') {
                this.handlePaste(e);
            } else if (!modifier) {
                this.current.input.focus();
            }
        }
        // Scroll
        if (e.ctrlKey && e.altKey) { // holding ctrl + alt
            if (e.which === Keyboard.KEYS.LEFT) {
                this.current.scroll.scrollToLastSeenOrTop();
                return false;
            } else if (e.which === Keyboard.KEYS.RIGHT) {
                this.current.scroll.scrollToBottomSeenOrBottom();
                return false;
            }
        }
        this.current.trigger('docKeyDown', e);

        if (Keyboard.isModifier(e, true) && e.altKey && e.which == Keyboard.KEYS.R) {
            // CmdOrCtrl-Alt-R: reply
            if (!this.currentThread || !this.currentThread.input.isFocused()) {
                var last = this.model.currentBuffer.messages.lastReplyable();
                if (last) {
                    this.model.setThreadId(this.model.currentBuffer.threadId(last.getReplyId()));
                    return false;
                }
            }
        }
        if (Keyboard.isModifier(e, true) && e.altKey && e.which == Keyboard.KEYS.COMMA) {
            this.model.trigger('navigate', '?/settings', {trigger: true});
        }
        if (e.shiftKey && !e.altKey && _.include([Keyboard.KEYS.UP, Keyboard.KEYS.DOWN], e.which)) {
            var cycleRet = false;
            if (this.currentThread && this.currentThread.input.isFocused()) {
                cycleRet = this.currentThread.cycleReplyHighlights(e.which);
            }
            if (cycleRet === false) {
                cycleRet = this.current.cycleReplyHighlights(e.which);
            }
            if (cycleRet) {
                return false;
            }
        }
    },
    docKeyUp: function (e) {
        if (this.current) {
            this.current.trigger('docKeyUp', e);
        }
    },
    resetBuffers: function () {
        for (var bid in this.buffers) {
            this.buffers[bid].remove();
        }
        this.buffers = {};
    },
    bufferRemoved: function (buffer) {
        delete this.buffers[buffer.bid()];
    },
    bufferAdded: function (buffer) {
        var options = {
            model: buffer
        };
        var overlayHandler = new BufferOverlayHandler(options);
        overlayHandler.on('addOverlay', this.renderCurrentOverlay, this);
        new BufferNotificationHandler(options);
        var promptHandler;
        if (buffer.isServerLog()) {
            promptHandler = new ConnectionPromptHandler(options);
        } else if (buffer.isChannel()) {
            promptHandler = new ChannelPromptHandler(options);
        } else if (buffer.isConversation()) {
            promptHandler = new ConversationPromptHandler(options);
        }
        if (promptHandler) {
            promptHandler.on('addOverlay', this.renderCurrentOverlay, this);
        }
    },
    bufferSelectedChange: function (buffer) {
        if (buffer.isSelected()) {
            var view = this.renderBuffer(buffer);
            this.renderThread(true);

            this.current = view;
            this.timeLayoutChange();
        }
    },
    checkDelayedLoads: function () {
        var bufViews = _.values(this.buffers);
        if (this.currentThread) {
            bufViews.push(this.currentThread);
        }
        var boundOnLoads = _.map(bufViews, function (bufferView) {
            return bufferView.scroll.log.checkDelayedLoads();
        });
        _.each(boundOnLoads, function (bufBoundOnLoads) {
            _.each(bufBoundOnLoads, function (boundOnLoad) {
                if (boundOnLoad) {
                    boundOnLoad();
                }
            });
        });
        setTimeout(_.bind(this.checkDelayedLoads, this), 2000);
    },
    renderThread: function (bufSelected) {
        var pinBottom;
        if (!bufSelected) {
            pinBottom = this.current.scroll.shouldPinBottom();
        }
        if (this.model.threadId) {
            var parts = this.model.threadId.split('-');
            var bid = parts.shift();
            var threadId = parts.join('-');
            var buffer = this.model.buffers.get(bid);

            if (buffer) {
                var thread = new Thread({
                    id: threadId
                }, {
                    buffer: buffer,
                    connection: buffer.connection,
                    session: this.model
                });

                if (this.currentThread) {
                    if (this.currentThread.model.equals(thread)) {
                        this.currentThread.focusInput();
                        return true;
                    }
                    this.clearCurrentThread();
                }

                thread.init();

                var view = new ThreadView({
                    model: thread,
                    buffer: buffer
                });
                view.bind('timeLayoutChange', this.timeLayoutChange, this);
                this.threadContainer.append(view.el);
                this.currentThread = view;
                this.threadContainer.show();
                view.show();
                if (!bufSelected) {
                    view.focusInput();
                    this.current.fullLayoutChange(pinBottom);
                }
                return true;
            }
        }
        this.clearCurrentThread();
        if (!bufSelected) {
            this.current.fullLayoutChange(pinBottom);
        }
        return false;
    },
    clearCurrentThread: function () {
        this.threadContainer.hide();
        if (this.currentThread) {
            this.currentThread.model.delete();
            this.currentThread = null;
        }
    },
    renderBuffer: function (buffer) {
        if (!this.buffers[buffer.bid()]) {
            var options = {
                model: buffer
            };
            var view;
            if (buffer.isServerLog()) {
                view = new ServerLogView(options);
            } else if (buffer.isChannel()) {
                view = new ChannelView(options);
            } else if (buffer.isConversation()) {
                view = new ConversationView(options);
            }
            this.buffers[buffer.bid()] = view;

            view.bind('timeLayoutChange', this.timeLayoutChange, this);
            view.bind('addOverlay', this.renderCurrentOverlay, this);

            this.buffersContainer.append(view.el);
            view.renderSelected();
        }
        return this.buffers[buffer.bid()];
    },
    showBuffers: function () {
        this.bufferPanes.addClass('canShow');
        this.timeLayoutChange();
        this.model.trigger('buffersShown');
    },
    hideBuffers: function () {
        this.bufferPanes.removeClass('canShow');
    },
    clearCurrent: function () {
        this.current = null;
        this.timeContainer.hide();
    },
    currentBufferChange: function () {
        if (!this.model.currentBuffer) {
            this.clearCurrent();
        }
    },
    doneLoading: function (inited) {
        if (!inited) {
            $('.mainSpin').remove();
        }
        this.timeLayoutChange();
    },
    highlightCurrentUserRows: function (user) {
        if (this.current && user.connection == this.model.currentBuffer.connection) {
            this.current.hoverUserRows(user);
        }
    },
    unhighlightCurrentUserRows: function () {
        if (this.current) {
            this.current.unhoverUserRows();
        }
    },
    renderCurrentOverlay: function (overlay) {
        if (this.current) {
            this.current.renderOverlay(overlay);
        } else if (this.addNetwork.isSelected()) {
            this.addNetwork.renderOverlay(overlay);
        } else if (this.settings.isSelected()) {
            this.settings.renderOverlay(overlay);
        }
    },

    // Layout callbacks

    currentBufferTopChange: function () {
        if (this.current) {
            this.current.mainTopChange();
        }
    }
});


module.exports = MainAreaView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/mainareaview.js
// module id = FHm1
// module chunks = 1